/* eslint-disable camelcase */
import compose from 'ramda/src/compose'
import { stringToBoolean, objToNumber, mappedIndex } from './general'

const migrateFloorPlan = (floorPlan, index) => {
  const { imageSrc, imageSize, position: { nw, se }, lock, scale } = floorPlan
  return {
    imageSrc,
    imageSize: objToNumber(imageSize),
    location: {
      nw: objToNumber(nw),
      se: objToNumber(se)
    },
    id: index,
    locked: stringToBoolean(lock),
    scaled: stringToBoolean(scale)
  }
}

export default compose(
  mappedIndex(migrateFloorPlan),
  Object.values
)



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/migrateFloorPlans.js